import setShouldSignInToSkypeOperation from 'owa-service/lib/operation/setShouldSignInToSkypeOperation';
import setShouldSignInToSkypeRequest from 'owa-service/lib/factory/setShouldSignInToSkypeRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function setShouldAutoSignIn(shouldAutoSignIn: boolean) {
    setShouldSignInToSkypeOperation(
        setShouldSignInToSkypeRequest({
            Header: getJsonRequestHeader(),
            ShouldSignIn: shouldAutoSignIn,
        })
    ).catch(() => {
        // No op
    });
}
